
















































import { Component, Vue, InjectReactive, Watch } from 'vue-property-decorator'
import Dashboard from './Dashboard.vue'
import AccessToken from '../access-token'
import RestClient from '../components/RestClient.vue'
import Account from '../account'
import { Dictionary } from 'vue-router/types/router'
declare const google: any

class Usage {
    requests: number
    elevations: number
    constructor(requests: number, elevations: number) {
        this.requests = requests
        this.elevations = elevations
    }
    static unmarshal(json: any): Usage {
        return new Usage(json.num_requests, json.num_elevations)
    }
}

enum Mode {
    Total = 'total',
    Trial = 'trial',
    Deleted = 'deleted',
    Token = 'token',
}

@Component
export default class VueComponent extends Vue {
    $parent!: Dashboard
    $log: any
    @InjectReactive() account?: Account
    usages?: Map<Date, Usage>
    total?: Map<Date, Usage>
    trial?: Map<Date, Usage>
    tokenUsages?: Map<string, Map<Date, Usage>>
    deleted?: Map<Date, Usage>
    tokenIds: string[] = []
    selectedTokenId?: string
    mode?: Mode
    data() {
        return {
            mode: null,
            usages: null,
            selectedTokenId: null,
        }
    }
    mounted() {
        google.charts.load('current', {'packages':['line', 'corechart']})
        google.charts.setOnLoadCallback(() => {
            this.refresh()
        })
    }
    @Watch('account')
    refresh() {
        if (this.account) {
            this.restClient.request('GET', '/v1/services/elevation/stats/daily', null, (data) => {
                var tokenUsages = new Map<string, Map<Date, Usage>>()
                var tokenIds: string[] = []
                if (data.token_stats) {
                    Object.keys(data.token_stats).forEach((id: string) => {
                        var st = data.token_stats[id]
                        var usages = tokenUsages.get(id)
                        if (!usages) {
                            usages = new Map<Date, Usage>()
                        }
                        if (usages) {
                            Object.keys(st.usages).forEach((time: string) => {
                                if (usages) {
                                    var usage = Usage.unmarshal(st.usages[time])
                                    usages.set(new Date(parseInt(time, 10)), usage)
                                }
                            })
                        }
                        tokenUsages.set(id, usages)
                        tokenIds.push(id)
                    })
                }
                this.tokenUsages = tokenUsages
                this.tokenIds = tokenIds
                this.total = this.unmarshalUsages(data.total)
                this.trial = this.unmarshalUsages(data.trial)
                this.deleted = this.unmarshalUsages(data.deleted)
                this.mode = Mode.Total
            })
        }
    }
    unmarshalUsages(json: any): Map<Date, Usage> {
        var usages = new Map<Date, Usage>()
        if (json) {
            Object.keys(json).forEach((key: string) => {
                usages.set(new Date(parseInt(key, 10)), Usage.unmarshal(json[key]))
            })
        }
        return usages
    }
    @Watch('mode')
    applyMode() {
        switch (this.mode) {
            case Mode.Total:
                this.usages = this.total
                break
            case Mode.Trial:
                this.usages = this.trial
                break
            case Mode.Deleted:
                this.usages = this.deleted
                break
            case Mode.Token:
                if (this.tokenUsages && this.selectedTokenId) {
                    var usages = this.tokenUsages.get(this.selectedTokenId)
                    if (usages) {
                        this.usages = usages
                    }
                }
                break
        }
    }
    @Watch('usages')
    applyUsages() {
        this.draw(this.usages)
    }
    draw(usages?: Map<Date, Usage>) {
        if (!usages || usages.size <= 0) {
            return
        }
        var data = new google.visualization.DataTable()
        data.addColumn('date', '日期')
        data.addColumn('number', "HTTP請求數量")
        data.addColumn('number', "高程轉換數量")
        usages.forEach((usage: Usage, time: Date) => {
            data.addRow([time, usage.requests, usage.elevations])
        })
        var dateRange = data.getColumnRange(0)
        if (data.getNumberOfRows() === 1) {
            let oneDay = (24 * 60 * 60 * 1000)
            dateRange.min = new Date(dateRange.min.getTime() - oneDay)
            dateRange.max = new Date(dateRange.max.getTime() + oneDay)
        }
        var options = {
            width: '100%',
            height: 500,
            hAxis: {
                format: 'MM/dd',
                viewWindow: dateRange,
            },
            vAxis: { minValue: 0 },
            legend: { position: 'bottom' }
        }
        var materialChart = new google.visualization.ScatterChart(document.getElementById('chart'))
        materialChart.draw(data, options)
    }
    get baseUrl() {
        return this.$parent.baseUrl
    }
    get restClient() {
        return this.$parent.restClient
    }
    get tokens(): AccessToken[] | undefined {
        return this.$parent.tokens
    }
    get selectedMode() { 
        return this.selectionName(this.mode, this.selectedTokenId)
    }
    get usageList() {
        var list: any[] = []
        if (this.usages) {
            this.usages.forEach((usage: Usage, time: Date) => {
                list.push({time: time, requests: usage.requests, elevations: usage.elevations})
            })
        }
        return list
    }
    selectionName(mode?: Mode, id?: string) {  
        switch (mode) {
            case Mode.Total:
                return '總使用量'
            case Mode.Trial:
                return '線上試用'
            case Mode.Deleted:
                return '已刪除的金鑰'
            case Mode.Token:
                if (this.tokens && id) {
                    for (var i = 0; i < this.tokens.length; i++) {
                        if (id == this.tokens[i].id) {
                            return this.tokens[i].name
                        }
                    }
                }
                break
        }      
        return undefined
    }
    selectToken(id: string) {
        this.selectedTokenId = id
        this.mode = Mode.Token
    }
    tokenName(id?: string) {
        if (!id) {
            return '不分金鑰'
        }
        if (this.tokens) {
            for (var i = 0; i < this.tokens.length; i++) {
                if (id == this.tokens[i].id) {
                    return this.tokens[i].name
                }
            }
        }
        return id
    }
}
